import '../lib/js-cookie-2.2.0';

function contactdropdown() {
  const fetchContactCards = target => {
    const id = target.dataset.id;
    const selectedValue = target.value;
    const contactCardsContainer = document.getElementById(id);
    if (contactCardsContainer) {
      const contactCards = [
        ...contactCardsContainer.querySelectorAll('.js-contact-card'),
      ];
      contactCards.forEach(card => {
        if (card.dataset.index === selectedValue) {
          card.classList.add('contact-card__area--show');
        } else {
          card.classList.remove('contact-card__area--show');
        }
      });
    }
  };

  const onCountryDropDownChange = e => {
    const target = e.currentTarget;
    fetchContactCards(target);
  };

  const init = () => {
    const countryDropDowns = [
      ...document.querySelectorAll('.js-contact-country-select'),
    ];

    const marketCookie = Cookies.get('Market');

    if (countryDropDowns.length) {
      countryDropDowns.forEach(dd => {
        dd.addEventListener('change', onCountryDropDownChange);

        if (marketCookie) {
          fetchContactCards(dd);
        }
      });
    }
  };

  init();
}
export default contactdropdown;
